import { userUpdateModel, userUpdateImage } from "../../../actions/user-actions"
import {
    autocompleteTopicsRequest,
    autocompletePermissionGroupsRequest,
    autocompleteCommunitiesRequest
} from "../../../actions/autocomplete-actions"

import buildItemConnector from "../../common/build-item-connector"

const mapDispatchToProps = dispatch => ({
    onStatusChange: ({ target: { name, checked } }) =>
        dispatch(userUpdateModel(name, checked ? "Active" : "Inactive"))
})

export default buildItemConnector(
    "users",
    false,
    userUpdateModel,
    userUpdateImage,
    {
        onTopicsSearch: autocompleteTopicsRequest,
        onPermissionGroupsSearch: autocompletePermissionGroupsRequest,
        onCommunitiesSearch: autocompleteCommunitiesRequest
    },
    null,
    mapDispatchToProps
)
